import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-MangoLogin',
  template: `
    <p>
      mango-login works!
    </p>
  `,
  styles: [
  ]
})
export class MangoLoginComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
